// // actions/sales.js
// import { ADD_SALE, FETCH_SALES, SHOW_SNACKBAR } from '../constants/actionTypes.js';
// import * as api from '../api/index.js';
// import { fetchNotifications } from './notifications.js';

// const STOCK_ALERT_TYPES = ['LOW_STOCK', 'CRITICALLY_LOW', 'OUT_OF_STOCK'];
// // details = payload you build in Cart (buildSalePayload)
// export const addSale = (details) => async (dispatch, getState) => {
//   console.log('addSale() payload from frontend:', details);

//   try {
//     // const { data } = await api.addSale(details);
//     // console.log('addSale() response from backend:', data);

//     // // adjust this line to match your backend response:
//     // // if your backend returns { message, sale }, then use data.sale
//     // // if it returns the created sale directly, data is the sale
//     // dispatch({
//     //   type: ADD_SALE,
//     //   payload: data.sale || data,
//     // });
//     // 1️⃣ Get previous notifications BEFORE sale
//     const prev = getState().notifications?.list || [];

//     // 2️⃣ Perform sale API call
//     const { data } = await api.addSale(details);
//     console.log('addSale() response from backend:', data);

//     dispatch({
//       type: ADD_SALE,
//       payload: data.sale || data,
//     });

//     // 3️⃣ Re-fetch notifications AFTER the sale
//     await dispatch(fetchNotifications());

//     const next = getState().notifications?.list || [];

//     // 4️⃣ Detect new stock alerts
//     const prevIds = new Set(prev.map(n => n._id));
//     const newStockAlerts = next.filter(
//       n => STOCK_ALERT_TYPES.includes(n.type) && !prevIds.has(n._id)
//     );

//     // 5️⃣ If new alerts exist → fire snackbar
//     if (newStockAlerts.length > 0) {
//       dispatch({
//         type: SHOW_SNACKBAR,
//         payload:
//           newStockAlerts.length === 1
//             ? "1 new stock alert. Check Alerts →"
//             : `${newStockAlerts.length} new stock alerts. Check Alerts →`,
//       });
//     }
//   } catch (error) {
//     console.error('addSale() error:', error.response?.data || error.message);
//   }
// };

// export const fetchSales = (params = {}) => async (dispatch) => {
//   try {
//     console.log('fetchSales() params:', params);
//     const { data } = await api.fetchSales(params);
//     console.log('fetchSales() response:', data);

//     dispatch({
//       type: FETCH_SALES,
//       payload: data,
//     });
//   } catch (err) {
//     console.error('fetchSales() error:', err.response?.data || err.message);
//   }
// };


// src/actions/sales.js
import {
  ADD_SALE,
  FETCH_SALES,
  SHOW_SNACKBAR,
} from '../constants/actionTypes.js';
import * as api from '../api/index.js';
import { fetchNotifications } from './notifications';

const STOCK_ALERT_TYPES = ['LOW_STOCK', 'CRITICALLY_LOW', 'OUT_OF_STOCK'];

const severityForType = (type) => {
  switch (type) {
    case 'OUT_OF_STOCK':
      return 'error';
    case 'CRITICALLY_LOW':
      return 'warning';
    case 'LOW_STOCK':
    default:
      return 'info';
  }
};

// details = payload you build in Cart (buildSalePayload)
export const addSale = (details) => async (dispatch, getState) => {
  console.log('addSale() payload from frontend:', details);

  try {
    // 1) Snapshot previous notifications
    const prev = getState().notifications?.list || [];

    // 2) Call backend to create sale
    const { data } = await api.addSale(details);
    console.log('addSale() response from backend:', data);
    

    dispatch({
      type: ADD_SALE,
      payload: data.sale || data,
    });

    // 3) Fetch updated notifications
    await dispatch(fetchNotifications());

    const next = getState().notifications?.list || [];

    // 4) Find new stock alerts created after this sale
    const prevIds = new Set(prev.map((n) => n._id));
    const newStockAlerts = next.filter(
      (n) =>
        STOCK_ALERT_TYPES.includes(n.type) &&
        !prevIds.has(n._id)
    );

    if (newStockAlerts.length === 0) {
      return; // no new stock alerts → no snackbar
    }

    // 5) If exactly one new stock alert → show specific message + color
    if (newStockAlerts.length === 1) {
      const a = newStockAlerts[0];
      const severity = severityForType(a.type);

      // Use backend's message if present. If you later add medicine name to Notification,
      // you can include it here.
      const message =
        a.message ||
        (a.type === 'OUT_OF_STOCK'
          ? 'An item is now out of stock. Check Alerts.'
          : a.type === 'CRITICALLY_LOW'
          ? 'An item is now critically low. Check Alerts.'
          : 'An item is now low on stock. Check Alerts.');

      dispatch({
        type: SHOW_SNACKBAR,
        payload: { message, severity },
      });
      return;
    }

    // 6) If multiple new alerts → build summary + severity by worst case
    const outCount = newStockAlerts.filter((n) => n.type === 'OUT_OF_STOCK').length;
    const critCount = newStockAlerts.filter((n) => n.type === 'CRITICALLY_LOW').length;
    const lowCount = newStockAlerts.filter((n) => n.type === 'LOW_STOCK').length;

    let severity = 'info';
    if (outCount > 0) severity = 'error';
    else if (critCount > 0) severity = 'warning';

    let parts = [];
    if (outCount > 0) parts.push(`${outCount} out of stock`);
    if (critCount > 0) parts.push(`${critCount} critically low`);
    if (lowCount > 0) parts.push(`${lowCount} low stock`);

    const summary = parts.join(', ');
    const message = `Stock alerts updated: ${summary}. Check Alerts`;

    dispatch({
      type: SHOW_SNACKBAR,
      payload: { message, severity },
    });
  } catch (error) {
    console.error('addSale() error:', error?.response?.data || error.message);

    // Optional: also show error snackbar
    dispatch({
      type: SHOW_SNACKBAR,
      payload: {
        message: 'Error completing sale. Please try again.',
        severity: 'error',
      },
    });
  }
};

export const fetchSales = (params = {}) => async (dispatch) => {
  try {
    console.log('fetchSales() params:', params);
    const { data } = await api.fetchSales(params);
    console.log('fetchSales() response:', data);

    dispatch({
      type: FETCH_SALES,
      payload: data,
    });
  } catch (err) {
    console.error('fetchSales() error:', err.response?.data || err.message);
  }
};
